import React, { useEffect } from 'react'
import CenterStage from '../../../Components/CenterStage/CenterStage'
import ShowcaseCarousel from '../../../Components/ShowcaseCarousel/ShowcaseCarousel'
import TextCaption from '../../../Components/TextCaption/TextCaption'
import imgStage from '../../../assets/ResponsibilityAndSocialCommitments/Diversity/Stage.jpg'
import img3 from '../../../assets/ResponsibilityAndSocialCommitments/Diversity/01.jpg'
import img2 from '../../../assets/ResponsibilityAndSocialCommitments/Diversity/2.jpg'
import img1 from '../../../assets/ResponsibilityAndSocialCommitments/Diversity/3.jpg'
import SectionHeader from '../../../Components/SectionHeader/SectionHeader'

const Diversity = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const carouselItems = [
        {
            imgSrc: img1,
        },
        {
            imgSrc: img2,
        }, {
            imgSrc: img3,
        },
    ]
    return (
        <div>
            <CenterStage imageSrc={imgStage} title={"MADE IN GERMANY - MADE BY DIVERSITY"}
                paragraph={"HANSA-FLEX is committed to diversity and tolerance and sets an example against xenophobia and racism."} />
            <TextCaption paragraph={"As a diverse mix of people and cultures from more than 60 nations and a global player in 42 countries, we do not tolerate any xenophobic behavior in our group of companies. By participating in this campaign, we want to make our position as clear as possible - for cosmopolitanism, tolerance and diversity and against any kind of hatred or incitement against foreigners and migrants. Let us live diversity together every day and never allow xenophobia and racism to gain the upper hand!"} />
            <SectionHeader title={"MADE BY DIVERSITY"}
                paragraph={"In order for our products and services to meet the needs of our different customers, our teams must also be diverse and flexible. We would like to briefly introduce the people behind our products and services."} />
            <ShowcaseCarousel carouselItems={carouselItems} isExploreButton={false} descDisplay='block' carouselType={1} />
        </div>
    )
}

export default Diversity